import { MARQUEE_ITEMS } from '@/data/content';

export default function Marquee({ variant = 'dark' }) {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      className={`relative overflow-hidden py-6 sm:py-8 border-y ${
        variant === 'gold' ? 'border-brand-gold/25 bg-brand-gold/5' : 'border-white/5 bg-night-surface'
      }`}
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-display uppercase tracking-wide text-4xl sm:text-6xl px-6 ${i % 2 === 0 ? 'text-stroke-white' : 'text-brand-gold/90'}`}>
              {item}
            </span>
            <span className="w-2 h-2 rotate-45 bg-brand-red/70 mx-2" />
          </span>
        ))}
      </div>
    </div>
  );
}
